import React from 'react';
import { COURSE_COUNT } from 'constants/site-stats.const';

import Link from 'next/link';

import { useQuery } from 'react-query';
import { initService } from 'services/core';

import GoogleButton from 'components/pages/auth/googlebutton/GoogleButton';
import FacebookButton from 'components/pages/auth/facebookbutton/FacebookButton';
import AppleButton from 'components/pages/auth/applebutton/AppleButton';
import LinkButton from '@core/components/linkbutton/LinkButton';
import BackButton from '@core/components/backbutton/BackButton';

import { NextSeo } from 'next-seo';
import { generateSeoProps } from 'router/seoprops/generateSeoProps';
import  RegisterCarousel from '@core/components/registercarousel/RegisterCarousel';

import MoileTopHeadear from 'assets/images/getstarted-top.svg';

import classes from './GetStarted.module.scss';



const GetStarted = () => {
	const { data: initData } = useQuery('app-init', initService);	
	const seoProps = generateSeoProps({
		title: 'Sign-Up: Start Pharma Career Training - Pharmuni',
		description: `Sign up in seconds to explore ${COURSE_COUNT} GMP, QA and regulatory courses, build your resume and accelerate your pharmaceutical career.`,
		canonical: 'get-started'
	});


	return (
		<>
			<NextSeo {...seoProps} />
			<div className={`${classes['wrapper']} `}>
				<div className="container">
					<div className="row">
						<div className='col-12 col-xl-6 p-0 d-flex align-items-center justify-content-center'>
							<div className={`${classes['getstarted-wrapper']} d-flex flex-column align-items-center `}>
								<BackButton className="d-block d-md-none" type="close" />
								<MoileTopHeadear />
								<div className={`${classes['getstarted']}  d-flex flex-column align-items-stretch`}>
									<h1>Register</h1>
									<p>Start learning and growing your career with Pharmuni!</p>
									<GoogleButton hidden={!initData?.data?.oauth?.google} className='hover-shrink'>
										{' '}
										Continue with Google
									</GoogleButton>
									<AppleButton hidden={!initData?.data?.oauth?.apple} className='hover-shrink'> Continue with Apple </AppleButton>

									<FacebookButton hidden={!initData?.data?.oauth?.facebook} className='hover-shrink'>
										Continue with Facebook
									</FacebookButton>
									<div className={`${classes['divider']} mt-3`}>or</div>
									<LinkButton
										className={`${classes['register-button']} d-flex align-items-center justify-content-center`}
										to="/register">
										Register with email
									</LinkButton>
									<p>
										Already registered? <Link href="/login">Login</Link>
									</p>
								</div>
							</div>
						</div>
						<div className='d-none d-xl-block col-xl-6 '>
							<RegisterCarousel />
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default GetStarted;
